import { dialog } from "../../../../../../nq-component";
import DialogModal from "../../../../../../components/Dialog";

function DialogDisapproved({ index, onSubmit }) {
  let reason = "";

  return (
    <div className="rounded-3 overflow-hidden" style={{ minWidth: "380px" }}>
      {/* Header */}
      <div
        className="px-4 py-3 d-flex align-items-center gap-3"
        style={{
          background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
        }}
      >
        <div
          className="d-flex align-items-center justify-content-center rounded-circle"
          style={{
            width: "42px",
            height: "42px",
            background: "rgba(255,255,255,0.2)",
          }}
        >
          <i
            className="bi bi-x-circle text-white"
            style={{ fontSize: "1.2rem" }}
          />
        </div>
        <div>
          <h6
            className="mb-0 text-white fw-bold"
            style={{ fontSize: "0.95rem" }}
          >
            Disapprove Request
          </h6>
          <small
            style={{ color: "rgba(255,255,255,0.8)", fontSize: "0.75rem" }}
          >
            Provide a reason for disapproval
          </small>
        </div>
      </div>

      {/* Body */}
      <div className="px-4 py-4" style={{ background: "#fff" }}>
        <label
          className="d-flex align-items-center gap-2 mb-2 fw-semibold"
          style={{ fontSize: "0.85rem", color: "#374151" }}
        >
          <i className="bi bi-chat-left-text" style={{ color: "#ef4444" }} />
          Reason for Disapproval
        </label>
        <textarea
          className="form-control rounded-3"
          rows="4"
          placeholder="Enter reason here..."
          style={{
            border: "1px solid #e5e7eb",
            padding: "10px 14px",
            fontSize: "0.9rem",
            resize: "vertical",
            transition: "border-color 0.2s ease, box-shadow 0.2s ease",
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "#ef4444";
            e.target.style.boxShadow = "0 0 0 3px rgba(239, 68, 68, 0.15)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = "#e5e7eb";
            e.target.style.boxShadow = "none";
          }}
          onChange={(e) => {
            reason = e.target.value;
          }}
        />
      </div>

      {/* Footer */}
      <div
        className="px-4 py-3 d-flex justify-content-end gap-2"
        style={{ background: "#f9fafb", borderTop: "1px solid #f0f0f0" }}
      >
        <button
          className="btn btn-sm fw-semibold px-4 py-2 rounded-3"
          style={{
            background: "#f3f4f6",
            border: "1px solid #e5e7eb",
            color: "#374151",
            fontSize: "0.85rem",
          }}
          onClick={() => dialog.close()}
        >
          Cancel
        </button>
        <button
          className="btn btn-sm fw-semibold px-4 py-2 rounded-3 text-white"
          style={{
            background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
            border: "none",
            fontSize: "0.85rem",
            transition: "all 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-1px)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(239,68,68,0.4)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "none";
          }}
          onClick={() => {
            if (!reason.trim()) {
              dialog.fire({
                html: (
                  <DialogModal
                    icon="bi bi-question-octagon-fill"
                    iconColor="#e74c3c"
                    title="Error"
                    message="Please provide a reason."
                    isCancelButton={false}
                    onSubmit={() => dialog.close()}
                    onClose={() => dialog.close()}
                  />
                ),
                footer: false,
              });
              return;
            }

            dialog.close();

            setTimeout(() => {
              dialog.fire({
                html: (
                  <DialogModal
                    icon="bi bi-question-octagon-fill"
                    iconColor="#82c14a"
                    title="Confirm Disapproval"
                    message="Are you sure you want to disapprove this request?"
                    isCancelButton={true}
                    onSubmit={() => onSubmit(index, reason)}
                    onClose={() => dialog.close()}
                  />
                ),
                footer: false,
              });
            }, 200);
          }}
        >
          <i className="bi bi-x-lg me-1" /> Disapprove
        </button>
      </div>
    </div>
  );
}

export default DialogDisapproved;
